import styled from 'styled-components';

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

export const LinkWrapper = styled.span`
  display: flex;
  gap: var(--spacing-xsmall);
`;
